/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Wallet(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 27.01 20.01'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        id='Layer_1-2'
                    >
                        <g
                            data-name='2019-Admin-enhancements'
                            id='_2019-Admin-enhancements'
                        >
                            <g id='icons'>
                                <g id='wallet-icon'>
                                    <g
                                        fill={iconColor || '#000'}
                                        id='Rectangle-8'
                                    >
                                        <path d='M24.13,20H2.88a3.3,3.3,0,0,1-1.73-.3,2,2,0,0,1-.85-.85A3.3,3.3,0,0,1,0,17.13V2.88A3.3,3.3,0,0,1,.3,1.15,2,2,0,0,1,1.15.3,3.3,3.3,0,0,1,2.88,0H24.13a3.3,3.3,0,0,1,1.73.3,2,2,0,0,1,.85.85A3.3,3.3,0,0,1,27,2.88V17.13a3.3,3.3,0,0,1-.3,1.73,2,2,0,0,1-.85.85A3.3,3.3,0,0,1,24.13,20ZM2.88,1a2.41,2.41,0,0,0-1.26.18,1,1,0,0,0-.43.43A2.41,2.41,0,0,0,1,2.88V17.13a2.41,2.41,0,0,0,.18,1.26,1,1,0,0,0,.43.43A2.53,2.53,0,0,0,2.88,19H24.13a2.48,2.48,0,0,0,1.25-.18,1,1,0,0,0,.44-.44A2.48,2.48,0,0,0,26,17.13V2.88a2.53,2.53,0,0,0-.18-1.26,1,1,0,0,0-.44-.43A2.36,2.36,0,0,0,24.13,1Z' />
                                    </g>
                                    <g
                                        fill={iconColor || '#000'}
                                        id='Rectangle-3'
                                    >
                                        <path d='M27,14H22a4,4,0,0,1,0-8h5ZM22,7a3,3,0,0,0,0,6h4V7Z' />
                                    </g>
                                    <g
                                        data-name='Rectangle-3'
                                        fill={iconColor || '#000'}
                                        id='Rectangle-3-2'
                                    >
                                        <path
                                            className='cls-1'
                                            d='M23,9a1,1,0,1,1-1,1A1,1,0,0,1,23,9Z'
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}